import { List } from "linqts";

export class UfList
{
    public static getUfs():List<any>
    {

        return  new List(
            [
                { name: "Acre - AC", id: "AC" },
                { name: "Alagoas - AL", id: "AL" },
                { name: "Amapá - AP", id: "AP" },
                { name: "Amazonas - AM", id: "AM" },
                { name: "Bahia - BA", id: "BA" },
                { name: "Ceara - CE", id: "CE" },
                { name: "Distrito Federal - DF", id: "DF" },
                { name: "Espírito Santo - ES", id: "ES" },
                { name: "Goiás - GO", id: "GO" },
                { name: "Maranhão - MA", id: "MA" },
                { name: "Mato Grosso - MT", id: "MT" },
                { name: "Mato Grosso do Sul - MS", id: "MS" },
                { name: "Minas Gerais - MG", id: "MG" },
                { name: "Paraná - PR", id: "PR" },
                { name: "Pará - PA", id: "PA" },
                { name: "Paraíba - PB", id: "PB" },
                { name: "Pernambuco - PE", id: "PE" },
                { name: "Piauí - PI", id: "PI" }, 
                { name: "Rio de Janeiro - RJ", id: "RJ" },
                { name: "Rio Grande do Norte - RN", id: "RN" },  
                { name: "Rio Grande do Sul - RS", id: "RS" },
                { name: "Rondônia - RO", id: "RO" },
                { name: "Roraima - RR", id: "RR" }, 
                { name: "Santa Catarina - SC", id: "SC" },  
                { name: "São Paulo - SP", id: "SP" },
                { name: "Sergipe - SE", id: "SE" },
                { name: "Roraima - RO", id: "RO" },
                { name: "Tocantins - TO", id: "TO" },
            
          
            ]);

            
    }
}


export class IntellibodyConstants
{
    public static getDocumentTypes():List<any>
    {
        return  new List(
            [
              { name: "Pessoa Física", id: 1 },
              { name: "Pessoa Juridica", id: 2 }
     
            ]);
    }

    public static getCustomerStatus():List<any>
    {
        return  new List(
            [
              { name: "Normal", id: 0 },
              { name: "Prospecto", id: 1 },
              { name: "Funcionário", id: 2 }
            ]);
    }
}

export class OreConstants
{
  
    public static getLicenseStatus():any[]
    {
        return [
               { name: "Normal", id: 0 },
               { name: "Fora de uso", id: 1 }
     
               ];
    }

    public static getPurchaseStatus():any[]
    {
        return [
               { name: "Aguardando pagamento", id: 0 },
               { name: "Pago", id: 2 },
               { name: "Cancelado", id: 3 },
               { name: "Desistencia", id: 4 },
               { name: "Em negociação", id: 5 },
               { name: "Nenhum", id: 99 },
               ];
    }

    public static getPurchaseTypes():any[]
    {
        return [
               { name: "Produto", id: 0 },
               { name: "Serviço", id: 1 },
           
               ];
    }

    public static getProductTypes():any[]
    {
        return [
               { name: "Licença", id: 0 },
               { name: "Adesão", id: 1 },
               { name: "Produto Físico", id: 2 },
               { name: "Outros Produtos", id: 3 },
               { name: "Serviço", id: 100 },
            
               ];
    }

}

